import { render, staticRenderFns } from "./AbyssusDescript.vue?vue&type=template&id=65540672&scoped=true"
var script = {}
import style0 from "./AbyssusDescript.vue?vue&type=style&index=0&id=65540672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65540672",
  null
  
)

export default component.exports